import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} DEWFOAM Furniture. All rights reserved.</p>
        <p className="footer-version">Version 1.0.0</p>
      </div>
    </footer>
  );
};

export default Footer;
